import { PieChart } from '@mui/x-charts/PieChart';
import { Card, CardContent, Typography } from '@mui/material';
import Loading from '../../components/loading';
import { useFinancialDashboardResource } from './hooks/useFinancialDashboardResource';

export function IncomesByCategoryPieChart({ selectedDate, viewByYear, viewAllPeriod }) {
  const { data: incomesByCategory, isLoading } = useFinancialDashboardResource(
    '/financial/dashboard/incomes-by-categories',
    { selectedDate, viewByYear, viewAllPeriod },
    [],
  );

  const data = incomesByCategory.map((item) => ({
    id: item.categoryId,
    value: item.totalAmount,
    label: `${item.categoryName} - ${item.totalAmountFormatted}`,
  }));

  return (
    <Card sx={{ position: 'relative' }}>
      <Loading isToHidden={isLoading === false} />
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Entradas por Categoria
        </Typography>

        <PieChart
          series={[
            {
              data,
              innerRadius: 50,
              outerRadius: 110,
              paddingAngle: 2,
              arcLabel: (item) => `R$ ${item.value.toLocaleString('pt-BR')}`,
              arcLabelMinAngle: 15,
            },
          ]}
          height={280}
        />
      </CardContent>
    </Card>
  );
}
